export default __webpack_public_path__ + "static/aws-deepracer-img-1-5ba7632e4f45061a1dbd65e6136922ba.jpg";